<template>
  <div class="sectionOuterBox bgBlue cWhite hero">
    <div class="sectionInnerBox textCenter py50">
      <div class="container">
        <div class="grid">
          <div class="col-12 text36 fontWeightBold">
            {{ $t('about.history.title') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class History extends Vue {
}
</script>

<style lang="scss" scoped></style>
